// from general.js
/* global dcAnalytics isTeacherUserPage */
// from JSP (sometimes via ProposalControllerService pageSpecificJsVariables)
/* global proposalId isEligibleForFunding fullyFunded currentWorkflowStatusCode isExpired
 teacherHasClassroomPhoto teacherHasProfilePhoto isEquityFocus */

import { getDistanceLearningType, isDistanceLearningProject } from './distanceLearning.js';
import { getHyphenatedFromCamelCase } from '../utils/stringUtils.ts';

function cleanSponsorCampaign(campaign) {
    return ((campaign) ? '-' + window.removeNonAlphaNumericChars(campaign) : '');
}

function getFirstSponsorCampaign() {
    const trackableItems = $('[data-track]');
    let sponsorCampaign = '';
    if (trackableItems.length > 0) {
        const trackData = trackableItems.eq(0).data('track');
        sponsorCampaign = window.removeNonAlphaNumericChars(cleanSponsorCampaign(trackData.sponsor.campaign));
    }
    return sponsorCampaign || '';
}

function trackProjectPageStatus() {
    const additionalDetails = {};
    additionalDetails.proposalId = proposalId;

    if (isEligibleForFunding) {
        additionalDetails.fundingStatus = 'open for funding';
    } else if (fullyFunded === 'true') {
        additionalDetails.fundingStatus = 'funded';
    } else if (currentWorkflowStatusCode < 6) {
        additionalDetails.fundingStatus = 'not yet screened';
    } else if (isExpired) {
        additionalDetails.fundingStatus = 'expired';
    } else {
        additionalDetails.fundingStatus = 'not open for funding';
    }

    if (isDistanceLearningProject()) {
        additionalDetails.dlpStatus = getDistanceLearningType();
    }

    // also add DYI2 marker
    const sponsorCampaign = getFirstSponsorCampaign();
    if (sponsorCampaign) {
        additionalDetails.matchStatus = sponsorCampaign;
    }

    additionalDetails.hasClassroomPhoto = teacherHasClassroomPhoto;

    additionalDetails.teacherHasProfilePhoto = teacherHasProfilePhoto;

    additionalDetails.teacherVisit = isTeacherUserPage();

    additionalDetails.isEquityFocus = isEquityFocus;

    dcAnalytics.track('Project Page View', additionalDetails);
    for (const key in additionalDetails) {
        if (additionalDetails.hasOwnProperty(key)) {
            const keyName = 'status - ' + getHyphenatedFromCamelCase(key).replace(/-/g, ' ');
            dcAnalytics.trackEventGANonInteraction(['Project Page', keyName, '' + additionalDetails[key]]);
        }
    }
}

$(document).ready(function () {
    trackProjectPageStatus();
});
